import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { RestApiService } from '../rest-api/rest-api.service';

@Injectable()
export class UserManagementService {
    constructor(private _restApi: RestApiService, private http: HttpClient) {}

    getUser() {
        let _url = `${environment.APIEndpoint}api/v1/User`;
        let p = this._restApi.requestGET<any>(_url, null, true, true);
        return p;
    }

    getBillingContact(id) {
        let _url = `${environment.APIEndpoint}api/v1/user/${id}`;
        let p = this._restApi.requestGET<any>(_url, null, true, true);
        return p;
    }

    getUserMock() {
        let _url = '/assets/mock/user.json';
        let p = this._restApi.requestGET<any>(_url, null, true, true);
        return p;
    }

    updateUser(user) {
        let _url = `${environment.APIEndpoint}api/v1/User/${user.id}/ChangePersonalData`;
        const p = this._restApi.requestRawBodyPOST<any>(_url, JSON.stringify(user), null, true, true);
        return p;
    }

    changePassword(username: string, oldPassword: string, newPassword: string) {
        let _url = `${environment.APIEndpoint}api/v1/User/ChangePassword`;
        let password = {
            password: newPassword
        };
        return this._restApi.requestRawBodyPOST<any>(_url, JSON.stringify(password), null, true, true);
    }
}
